export default "__VITE_ASSET__Cnzp2bcr__"